import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import BiotechRoundedIcon from '@mui/icons-material/BiotechRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { Link as RouterLink } from 'react-router-dom';

const HIGHLIGHTS = [
  'CDISC SDTM domain coverage (DM, AE, LB, VS, EX, DS)',
  'MedDRA-coded adverse events by therapeutic area',
  'Phase I–IV multi-arm trial designs',
  'REST API for CI/CD pipeline integration',
];

export default function LifeSciencesCallout() {
  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #040d1a 0%, #071a12 60%, #040d1a 100%)',
        borderTop: '1px solid rgba(52,211,153,0.15)',
        borderBottom: '1px solid rgba(52,211,153,0.15)',
        py: { xs: 8, sm: 12 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              <Chip
                label="LIFE SCIENCES"
                size="small"
                icon={<BiotechRoundedIcon sx={{ fontSize: '0.9rem !important' }} />}
                sx={{
                  width: 'fit-content',
                  background: 'rgba(52,211,153,0.1)',
                  border: '1px solid rgba(52,211,153,0.3)',
                  color: '#34d399',
                  fontWeight: 700,
                  fontSize: '0.72rem',
                  letterSpacing: '0.08em',
                }}
              />
              <Typography
                variant="h4"
                sx={{ fontWeight: 700, color: '#f0f9ff', lineHeight: 1.25 }}
              >
                Building for clinical trials or EDC pipelines?
              </Typography>
              <Typography variant="body1" sx={{ color: '#94a3b8', lineHeight: 1.75 }}>
                Cynthia has a dedicated life sciences mode that generates CDISC
                SDTM-compliant synthetic trial data — MedDRA-coded adverse events,
                realistic lab panels, and multi-arm protocol designs. No IRB waivers,
                no BAAs, no waiting.
              </Typography>
              <Button
                component={RouterLink}
                to="/life-sciences"
                variant="outlined"
                size="large"
                sx={{
                  width: 'fit-content',
                  mt: 1,
                  borderColor: 'rgba(52,211,153,0.4)',
                  color: '#34d399',
                  fontWeight: 600,
                  '&:hover': {
                    borderColor: '#34d399',
                    bgcolor: 'rgba(52,211,153,0.06)',
                  },
                }}
              >
                Explore Life Sciences Platform →
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack spacing={1.5}>
              {HIGHLIGHTS.map((h) => (
                <Stack key={h} direction="row" spacing={1.5} alignItems="flex-start">
                  <CheckCircleOutlineRoundedIcon
                    sx={{ color: '#34d399', opacity: 0.8, fontSize: '1.1rem', mt: '2px', flexShrink: 0 }}
                  />
                  <Typography variant="body2" sx={{ color: '#94a3b8', lineHeight: 1.6 }}>
                    {h}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
